import { render } from "./FaIcon.vue?vue&type=template&id=32f4e156&scoped=true"
import script from "./FaIcon.vue?vue&type=script&lang=js"
export * from "./FaIcon.vue?vue&type=script&lang=js"

import "./FaIcon.vue?vue&type=style&index=0&id=32f4e156&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f4e156"]])

export default __exports__